import { Turbo } from '@hotwired/turbo-rails';

export async function visitPlayerScreen(url) {
  const modal = window.modal;
  if (modal?.element.isConnected) {
    if (modal.hidingModal) {
      await new Promise((resolve) => modal.turboFrame.addEventListener('modal:closed', resolve, { once: true }));
    } else {
      await modal.hideModalWithPromise();
    }
  }
  Turbo.visit(url);
}
